var GA4DataLayerEvent = (function () {
    function GA4DataLayerEvent(event, ecommerce, user) {
        this.event = event;
        this.ecommerce = ecommerce;
        if (user) {
            this.user = user;
        }
    }
    return GA4DataLayerEvent;
}());
export { GA4DataLayerEvent };
//# sourceMappingURL=GA4DataLayerEvent.js.map